import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bfLogo from "../assets/bf_logo.png";
import "./LegalPages.css";

const AGBPage = () => {
  const navigate = useNavigate();

  // "Smart" kalbos parinkimas
  const [lang, setLang] = useState(() => {
    const browserLang = navigator.language || navigator.userLanguage || "de";
    return browserLang.startsWith("en") ? "en" : "de";
  });

  const t = {
    de: {
      title: "Allgemeine Geschäftsbedingungen (AGB)",
      back: "Zurück",
      binding: "Stand: Januar 2026. Diese AGB regeln die Nutzung der SaaS-Software BuildForce AL.",
      sections: [
        { 
          h: "1. Geltungsbereich", 
          p: "Diese AGB gelten für alle Geschäftsbeziehungen zwischen BuildForce AL (Anbieter, registriert in Zypern) und dem Kunden (Unternehmer). Das Angebot richtet sich ausschließlich an gewerbliche Kunden (B2B) in der DACH-Region und der EU." 
        },
        { 
          h: "2. Vertragsgegenstand", 
          p: "Der Anbieter stellt dem Kunden eine webbasierte Software für Workforce-Management als Software-as-a-Service (SaaS) zur Verfügung. Der Funktionsumfang ergibt sich aus der gewählten Plan-Beschreibung. Die Lizenz ist auf eine einzige juristische Person beschränkt. Die Nutzung durch mehrere Unternehmen über ein Konto ist untersagt." 
        },
        { 
          h: "3. Laufzeit & Kündigung", 
          p: "Die Mindestvertragslaufzeit beträgt 12 Monate. Der Vertrag verlängert sich automatisch um jeweils weitere 12 Monate, sofern er nicht schriftlich mit einer Frist von 3 Monaten zum Laufzeitende gekündigt wird." 
        },
        { 
          h: "4. Preise und Zahlungsbedingungen", 
          // ČIA PAPILDYTA SAKINIU APIE BLOKAVIMĄ:
          p: "Alle Preise verstehen sich netto zzgl. gesetzlicher Umsatzsteuer. Die Zahlung erfolgt wahlweise jährlich im Voraus oder monatlich. Im Falle einer monatlichen Zahlung bleibt die Verpflichtung für die gesamte Jahreslaufzeit bestehen. Gerät der Kunde in Zahlungsverzug, ist der Anbieter berechtigt, den Zugang zur Software bis zur vollständigen Zahlung vorübergehend zu sperren." 
        },
        { 
          h: "5. Verfügbarkeit", 
          p: "Der Anbieter gewährleistet eine Verfügbarkeit der Software von 99% im Jahresmittel. Ausgenommen sind Wartungsarbeiten und Störungen, die nicht im Einflussbereich des Anbieters liegen (z.B. Serverausfälle beim Cloud-Provider)." 
        },
        { 
          h: "6. Gerichtsstand & Haftung", 
          p: "Es gilt das Recht der Republik Zypern. Ausschließlicher Gerichtsstand ist Nikosia. Der Anbieter haftet unbeschränkt nur für Vorsatz und grobe Fahrlässigkeit." 
        }
      ]
    },
    en: {
      title: "General Terms and Conditions (GTC)",
      back: "Back",
      binding: "Status: January 2026. These GTC govern the use of the SaaS software BuildForce AL.",
      sections: [
        { 
          h: "1. Scope of Application", 
          p: "These GTC apply to all business relationships between BuildForce AL (Provider, registered in Cyprus) and the Customer (Business entity). The offer is aimed exclusively at commercial customers (B2B) in the DACH region and the EU." 
        },
        { 
          h: "2. Subject of Contract", 
          p: "The Provider provides the Customer with web-based software for workforce management as Software-as-a-Service (SaaS). The scope of functions results from the selected plan description. The license is restricted to a single legal entity. Use by multiple companies via one account is prohibited." 
        },
        { 
          h: "3. Term & Termination", 
          p: "The minimum contract term is 12 months. The contract automatically extends for another 12 months unless cancelled in writing with a notice period of 3 months prior to the end of the term." 
        },
        { 
          h: "4. Prices and Payment Terms", 
          // ČIA PAPILDYTA SAKINIU APIE BLOKAVIMĄ ANGLIŠKAI:
          p: "All prices are net plus statutory VAT. Payment is made either annually in advance or monthly. In the case of monthly payment, the obligation for the entire annual term remains. If the customer is in default of payment, the Provider is entitled to temporarily block access to the software until full payment is made." 
        },
        { 
          h: "5. Availability", 
          p: "The Provider guarantees software availability of 99% on an annual average. Maintenance work and disruptions outside the Provider's control (e.g., cloud provider outages) are excluded." 
        },
        { 
          h: "6. Jurisdiction & Liability", 
          p: "The laws of the Republic of Cyprus shall apply. The exclusive place of jurisdiction is Nicosia. The Provider is liable without limitation only for intent and gross negligence." 
        }
      ]
    }
  };

  return (
    <div className="legal-body">
      <nav className="legal-navbar">
        <div className="nav-container">
          <div className="logo-container" onClick={() => navigate("/")} style={{cursor: 'pointer'}}>
            <img src={bfLogo} alt="BF" className="bf-nav-logo" />
            <div className="logo-text">BUILDFORCE <span>AL</span></div>
          </div>
          <div className="nav-right">
            <div className="lang-switcher">
              <span onClick={() => setLang("en")} className={lang === "en" ? "active-lang" : ""}>EN</span>
              <span className="lang-divider">|</span>
              <span onClick={() => setLang("de")} className={lang === "de" ? "active-lang" : ""}>DE</span>
            </div>
            <button className="back-home-btn" onClick={() => navigate("/")}>{t[lang].back}</button>
          </div>
        </div>
      </nav>
      <div className="legal-content">
        <h1>{t[lang].title}</h1>
        <p className="binding-notice">{t[lang].binding}</p>
        {t[lang].sections.map((s, i) => (
          <div key={i} className="legal-section">
            <h2>{s.h}</h2>
            <p>{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AGBPage;